// extracted by mini-css-extract-plugin
export default {"root":"Footer_root__ciJQb","alteonLink":"Footer_alteonLink__UZlmJ","alteonLogo":"Footer_alteonLogo__ybEz3"};